@if (isAuthenticated() && showWidget()) {
    <div
        class="casino-rp-fav-toggle-section"
        [style.backgroundImage]="'url(' + currentCategoryInfo()?.sitecoreData?.fullTakeOverStaticBackgroundImage?.src + ')'">
        <cc-rp-fav-toggle-widget
            [categoryId]="categoryId()"
            [category]="category()"
            [isTouch]="isTouch()"
            [lobbyType]="lobbyType()"
            [gameContainer]="gameContainer()"
            [recentGames]="recentGames()"
            [favGames]="favGames()">
        </cc-rp-fav-toggle-widget>
    </div>
}
